import React from "react";
import "./OrsanLogoLoader.css";

/**
 * Loading screen z Orsan logom in/ali vrtljivim krogec (blagovna barva).
 *
 * @param {boolean} fullscreen – celozaslonsko ozadje
 * @param {'full' | 'circleOnly'} variant – full: logo + krogec; circleOnly: samo krogec (hitrejši prvi prikaz)
 */
const OrsanLogoLoader = ({ fullscreen = true, variant = "full" }) => (
  <div
    className={`orsan-logo-loader ${fullscreen ? "orsan-logo-loader--fullscreen" : ""} orsan-logo-loader--${variant}`}
    role="status"
    aria-live="polite"
    aria-label="Nalaganje strani"
  >
    <div className="orsan-logo-loader__inner">
      {variant === "full" && (
        <img
          src="/images/LOGO-large-white-1536x489.png"
          alt=""
          className="orsan-logo-loader__img"
        />
      )}
      {variant === "circleOnly" && (
        <div className="orsan-logo-loader__rings" aria-hidden="true">
          <div className="orsan-logo-loader__ring orsan-logo-loader__ring--outer" />
          <div className="orsan-logo-loader__ring orsan-logo-loader__ring--inner" />
        </div>
      )}
      {variant === "full" && (
        <div className="orsan-logo-loader__circle" aria-hidden="true" />
      )}
    </div>
  </div>
);

export default OrsanLogoLoader;
